
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.201","height":"19.379"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 14298","opacity":".87","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.2"}},[_c('path',{attrs:{"data-name":"Path 632","d":"M7.671 15.917a1.972 1.972 0 0 0-.5-2.02c-.5-.673-1.178-1.262-1.6-1.936a4.714 4.714 0 0 1-.594-4.46 4.072 4.072 0 0 1 3.114-2.357 4.1 4.1 0 0 1 1.01-.084 4.1 4.1 0 0 1 1.01.084 3.942 3.942 0 0 1 3.114 2.357 4.5 4.5 0 0 1-.588 4.459c-.5.673-1.094 1.347-1.6 1.936a1.972 1.972 0 0 0-.5 2.02"}}),_c('path',{attrs:{"data-name":"Path 633","d":"M9.101 15.916v-5.3"}}),_c('path',{attrs:{"data-name":"Path 634","d":"M7.584 9.184l1.515 1.515 1.6-1.515"}}),_c('path',{attrs:{"data-name":"Line 130","d":"M8.932 2.788V.6"}}),_c('path',{attrs:{"data-name":"Line 131","d":"M2.788 9.689H.6"}}),_c('path',{attrs:{"data-name":"Line 132","d":"M17.6 9.689h-2.188"}}),_c('path',{attrs:{"data-name":"Line 133","d":"M15.16 3.714l-1.599 1.515"}}),_c('path',{attrs:{"data-name":"Line 134","d":"M4.64 5.229L3.125 3.714"}}),_c('path',{attrs:{"data-name":"Line 135","d":"M6.829 16.59h4.461"}}),_c('path',{attrs:{"data-name":"Line 136","d":"M7.838 18.779h2.441"}})])])
          )
        }
      }
    